module.exports = __webpack_public_path__ + "img/concerts.34c59df2.png";